<div class="row order-line">
  <div class="col-12 col-sm-6 col-lg-3 image">
    <img [src]="imgUrl" [attr.alt]="name | translate">
  </div>
  <div class="col-12 col-sm-6 col-lg-5 details">
    <div class="name">{{ name | translate}}</div>
    <div class="description">{{ description | translate}}</div>
    <div class="count-managemnt row">
      <div class="count">
        {{ count}}
      </div>
      <div class="count-description"> {{ 'Count' | translate }}</div>
      <div class="controls">
        <div class="up">
          <app-count-button [disabled]="!canCountUp" [faIcon]="faCaretUp" (singleClick)="onClickCountChangeByOne(true)"
            cssClass="edit-counter" [ngClass]="{'fa-disabled': !canCountUp}"></app-count-button>
        </div>
        <div class="down">
          <app-count-button [disabled]="!canCountDown" [faIcon]="faCaretDown"
            (singleClick)="onClickCountChangeByOne(false)" cssClass="edit-counter"
            [ngClass]="{'fa-disabled': !canCountDown}"></app-count-button>
        </div>
      </div>
    </div>
    <div *ngIf="canRemoveLine" (click)="onRemoveLineClick()" class="basket-delete-article">
      <div class="svg-container" [inlineSVG]="'assets/svg/icon/trash-solid.svg'"></div>
    </div>
  </div>
  <div class="col-12 col-lg-4 price">
    {{ toMoneyStr(price) }}
  </div>
</div>
